import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client.js';

/** CSAGE-268: SFTP credential store — names + metadata only; keys are write-only. */
export interface SftpCredential {
  id: string;
  name: string;
  createdAt: string;
  hasPassphrase: boolean;
}

export function useSftpCredentials(enabled = true) {
  const api = useApi();
  return useQuery<SftpCredential[]>({
    queryKey: ['sftp-credentials'],
    queryFn: () => api.fetch('/sftp-credentials'),
    enabled,
  });
}

export function useUpsertSftpCredential() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; privateKey: string; passphrase?: string }) =>
      api.fetch<SftpCredential>('/sftp-credentials', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['sftp-credentials'] });
    },
  });
}

export function useDeleteSftpCredential() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) =>
      api
        .fetchRaw(`/sftp-credentials/${encodeURIComponent(name)}`, { method: 'DELETE' })
        .then((r) => {
          if (!r.ok && r.status !== 204) throw new Error(`Delete failed: ${r.status}`);
        }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['sftp-credentials'] });
    },
  });
}
